import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FeedbackAnswer } from '../../_models/student-feedback/feedback-answer.model';
import { FeedbackSurvey } from '../../_models/student-feedback/feedback-survey.model';

@Injectable({
  providedIn: 'root'
})
export class StudentVoiceHelperService {
  private _modalSubmitTriggered: Subject<boolean> = new Subject<boolean>();

  public disableModalSubmit: boolean = true;
  
  constructor() { }

  public calculateAnswerIconClass(survey: FeedbackSurvey): FeedbackSurvey {
    let surveyIconSet = survey.feedbackIconsToUse;
    survey.feedbackQuestionList.forEach(question => {
      question.feedbackAnswerData.forEach(answer => {
        this.calculate(answer, surveyIconSet);
      });
      if (question.feedbackAdditionalQuestionData) {
        question.feedbackAdditionalQuestionData.followUpQuestionList.forEach(followUpQuestion => {
          followUpQuestion.feedbackAnswerData.forEach(followUpAnswer => {
            this.calculate(followUpAnswer, surveyIconSet);
          });
        });
      }
    });

    return survey;
  }

  public checkAllQuestionsAnswered(survey: FeedbackSurvey): boolean {
    return survey.feedbackQuestionList.every(question => {
      let questionAnswer = question.feedbackAnswerData.find(a => a.selectedAnswer != null);
      if (questionAnswer && question.feedbackAdditionalQuestionData && questionAnswer.feedbackAnswerValue <= question.feedbackAdditionalQuestionData.triggerOnAnswerLessThan) {
        let allAdditionalQuestionsAnswered = question.feedbackAdditionalQuestionData.followUpQuestionList.every(followUpQuestion => {
          return followUpQuestion.feedbackAnswerData.find(fa => fa.selectedAnswer != null) != undefined;
        });
        return allAdditionalQuestionsAnswered;
      }
      return questionAnswer != undefined;
    });
  }

  public modalSubmit(): void {
    this._modalSubmitTriggered.next(true);
  }

  public modalSubmitTriggered(): Observable<boolean> {
    return this._modalSubmitTriggered;
  }

  private calculate(answer: FeedbackAnswer, surveyIconSet: string): FeedbackAnswer {
    if (!answer.feedbackIconsToUse) {
      answer.calculatedIconClass = surveyIconSet.toLowerCase();
    } else {
      answer.calculatedIconClass = answer.feedbackIconsToUse.toLowerCase();
    }

    switch (answer.feedbackAnswerIconCode) {
      case 'SUPERB':
        answer.calculatedIconClass += " feedback-superb-icon";
        break;
      case 'GOOD':
        answer.calculatedIconClass += " feedback-good-icon";
        break;
      case 'OKAY':
        answer.calculatedIconClass += " feedback-ok-icon";
        break;
      case 'TERRIBLE':
        answer.calculatedIconClass += " feedback-terrible-icon";
        break;
      case 'THUMBSUP':
        answer.calculatedIconClass += " feedback-thumbs-up-icon";
        break;
      case 'THUMBSDOWN':
        answer.calculatedIconClass += " feedback-thumbs-down-icon";
        break;
    
      default:
        break;
    }

    return answer;
  }
}
